export default __webpack_public_path__ + "static/media/tour_ML_finance.90a1282f.png";